/*
  RMS ZEITMEISTER — Evrensel dil oneki duzeltici
  ------------------------------------------------------------------
  SORUN: Uygulama bloklari (ozellikle urun sayfasindaki "AI product
  recommendations", sinif ai-product-recs-slider-*) linkleri /tr/ oneki
  OLMADAN uretiyor. Turkce sayfadan tiklayan kullanici Ingilizceye dusuyor.

  COZUM: Sayfanin locale koku varsayilan degilse (/tr, /de), oneksiz
  icerik linklerine kok eklenir. Sonradan JS ile basilan linkler
  MutationObserver ile, gozden kacan tek tuk link de tiklama aninda
  (capture fazi) yakalanir.

  DOKUNULMAYANLAR — bilerek disarida:
  · Dil/para birimi degistirici linkleri (hreflang, localization formu,
    Convercy .cvc-*) — bunlar dili DEGISTIRMEK icin var.
  · Zaten bir locale oneki tasiyan linkler (/tr/..., /de/...).
  · Dis alan adlari, mailto:, tel:, #cengel.
  · /cart ve /account — odeme ve hesap akisini bozmamak icin.
  · data-rms-no-locale tasiyan linkler (elle muafiyet).

  Hata ayiklama: konsolda RMS_LOCALE_LINKS.audit()
  ------------------------------------------------------------------
*/
(function () {
  'use strict';

  var tv = window.themeVariables;
  var root =
    window.RMS_LOCALE_ROOT ||
    (tv && tv.routes && tv.routes.rootUrl) ||
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    '/';

  // "/tr/" -> "/tr"  ·  "/" -> ""
  var prefix = String(root).replace(/\/+$/, '');
  if (!prefix) return; // varsayilan dil (Ingilizce) — yapacak is yok

  var LOCALES = window.RMS_LOCALES || ['en', 'tr', 'de'];

  var CONTENT_ROUTE = /^\/(products|collections|pages|blogs|policies|search)(\/|$)/;

  var SKIP_SELECTOR =
    '[data-rms-no-locale],[hreflang],[class*="cvc-"] a,.shopify-localization-form a';

  function localizePath(path) {
    var seg = path.split('/')[1] || '';
    if (LOCALES.indexOf(seg) !== -1) return path; // zaten onekli
    if (!CONTENT_ROUTE.test(path)) return path;   // icerik rotasi degil
    return prefix + path;
  }

  function fix(a) {
    if (!a || a.nodeType !== 1 || a.tagName !== 'A') return;
    var href = a.getAttribute('href');
    if (!href) return;
    if (a.matches && a.matches(SKIP_SELECTOR)) return;
    if (a.closest && a.closest('[data-rms-no-locale],form[action*="/localization"]')) return;

    // Mutlak URL — yalnizca ayni alan adi
    if (/^https?:\/\//i.test(href)) {
      var u;
      try { u = new URL(href); } catch (e) { return; }
      if (u.origin !== window.location.origin) return;
      var np = localizePath(u.pathname);
      if (np === u.pathname) return;
      a.setAttribute('href', u.origin + np + u.search + u.hash);
      return;
    }

    if (href.charAt(0) !== '/' || href.charAt(1) === '/') return;

    var q = href.indexOf('?'), h = href.indexOf('#');
    var cut = Math.min(q < 0 ? href.length : q, h < 0 ? href.length : h);
    var path = href.slice(0, cut);
    var fixed = localizePath(path);
    if (fixed === path) return;
    a.setAttribute('href', fixed + href.slice(cut));
  }

  function scan(node) {
    if (!node || (node.nodeType !== 1 && node.nodeType !== 9)) return;
    if (node.nodeType === 1 && node.tagName === 'A') fix(node);
    var links = node.querySelectorAll ? node.querySelectorAll('a[href]') : [];
    for (var i = 0; i < links.length; i++) fix(links[i]);
  }

  function run() { scan(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Sonradan basilan bloklar (AI onerileri, hizli gorunum, filtre sonuclari)
  if (window.MutationObserver) {
    var queued = false;
    var pending = [];
    var flush = function () {
      queued = false;
      var list = pending;
      pending = [];
      for (var i = 0; i < list.length; i++) scan(list[i]);
    };
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes') { fix(r.target); continue; }
        for (var j = 0; j < r.addedNodes.length; j++) {
          if (r.addedNodes[j].nodeType === 1) pending.push(r.addedNodes[j]);
        }
      }
      if (!queued && pending.length) {
        queued = true;
        if (window.requestAnimationFrame) { window.requestAnimationFrame(flush); }
        else { window.setTimeout(flush, 0); }
      }
    });
    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  // Son savunma hatti: gozden kacan link tiklandigi anda duzeltilir
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href]') : null;
    if (a) fix(a);
  }, true);

  window.RMS_LOCALE_LINKS = {
    root: prefix,
    locales: LOCALES,
    fix: fix,
    rescan: run,
    audit: function () {
      var bad = [];
      var links = document.querySelectorAll('a[href^="/"]');
      for (var i = 0; i < links.length; i++) {
        var p = links[i].getAttribute('href').split(/[?#]/)[0];
        if (localizePath(p) !== p) bad.push(links[i].getAttribute('href'));
      }
      return { broken: bad.length, hrefs: bad };
    }
  };
})();
